import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ExitReleaseFocus extends Action<StorymapState> {
    public static ACTION_TYPE = 'ExitReleaseFocus';

    public constructor() {
        super(ExitReleaseFocus.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const middleware = async (state: StorymapState, action: ExitReleaseFocus): Promise<boolean> => {
    return true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: ExitReleaseFocus): void => {
    state.releases.forEach((x) => (x.isFocused = false));
};

//@ts-ignore
registerMiddleware(ExitReleaseFocus.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ExitReleaseFocus.ACTION_TYPE, reducer);
